import { pxToRem } from 'utils/convert';

export enum TABLE_COLUMNS {
  NAME = 'Name',
  TYPE = 'Type',
  OVERFLOW = 'Overflow',
}

export const ORDERED_TABLE_COLUMNS = [
  TABLE_COLUMNS.NAME,
  TABLE_COLUMNS.TYPE,
  TABLE_COLUMNS.OVERFLOW,
];

export const TABLE_COLUMNS_WIDTHS = {
  [TABLE_COLUMNS.NAME]: '2.5fr',
  [TABLE_COLUMNS.TYPE]: '2fr',
  [TABLE_COLUMNS.OVERFLOW]: pxToRem(65),
};

export enum LIST_TYPES {
  STANDARD = 'Standard',
  DYNAMIC = 'Dynamic',
  INTERNAL = 'Internal',
  SUPPRESSION = 'Suppression',
}

export const LIST_TYPE_NAMES = <Record<LIST_TYPES | string, string>>{
  [LIST_TYPES.STANDARD]: 'Static',
  [LIST_TYPES.DYNAMIC]: 'Dynamic',
  [LIST_TYPES.INTERNAL]: 'Internal',
  [LIST_TYPES.SUPPRESSION]: 'Suppression',
};
